let config = {
  endPoint: {
    prod: 'https://ps.bankrate.com/',
    qa: 'https://ps.qa.bankrate.com/',
    dev: 'https://ps.qa.bankrate.com/'
  },
  personalEndPoint: {
    prod: 'https://api.thesimpledollar.com/',
    staging: 'https://stag-api.thesimpledollar.com/'
  }
}

/**
 * This function determines the current environment
 *
 * @param host: the current host environment
 * @returns {string} the environment derived from the host string
 */
let determineEnv = host => {
  let env = 'prod'

  if (/xq|qa/i.test(host)) {
    env = 'qa'
  }

  if (/dev|local|castle/i.test(host)) {
    env = 'dev'
  }

  return env
}

/**
 * This function determines the current environment
 *
 * @param key: the key to get
 * @param host: the current host environment
 * @returns {string} the passed value from the key based on the current environment
 */
let getConfig = (key = 'endPoint', host = window.location.host) =>
  config[key][determineEnv(host)]

/**
 * This function builds the endpoint for the rate table service API
 *
 * @param vertical: the vertical (service) to use
 * @param host: the current host environment
 * @returns {string} the current environment endpoint
 */
let setEndpoint = (
  vertical = 'Auto',
  host = window.location.host,
  isFeatured = false
) => {
  if (vertical === 'Personal' || vertical == 'Auto') {
    let env

    if (/dev|local|castle|sandbox|xq007/.test(window.location.host)) {
      env = 'staging'
    } else {
      env = 'prod'
    }

    let type = isFeatured ? 'featured' : 'offers'

    return config['personalEndPoint'][env] + type
  } else {
    return (
      getConfig('endPoint', host) +
      vertical +
      getConfig(vertical.toLowerCase() + 'EndPointVersion', host)
    )
  }
}

export default {
  determineEnv: determineEnv,
  config: config,
  getConfig: getConfig,
  setEndpoint: setEndpoint
}
